"use client"

import { games } from "../lib/games"
import { GameCard } from "./game-card"

export function GameGrid() {
  return (
    <section className="container mx-auto px-4 py-20">
      <div className="mb-12 flex items-end justify-between border-b border-white/10 pb-6">
      <div>
  <h2 className="text-3xl font-bold text-foreground">Koleksi Game Siswa RPL</h2>
  <p className="mt-2 text-muted-foreground">Pilih game untuk melihat detailnya</p>
</div>

        <div className="hidden text-sm text-muted-foreground sm:block">
          Menampilkan {games.length} game
        </div>
      </div>

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {games.map((game, index) => (
          <GameCard key={game.id} game={game} index={index} />
        ))}
      </div>
    </section>
  )
}
